import { ChevronLeftIcon } from "@/components/Icons";

const PageHeader = ({
  isScrolled,
  onBack,
  children,
}: {
  isScrolled: boolean;
  /** Omit to hide back while leaving would abandon work in progress. */
  onBack?: () => void;
  children?: React.ReactNode;
}) => (
  <header
    className={`shrink-0 z-20 transition-all duration-300 ${
      isScrolled ? "glass-thin rounded-none" : "bg-transparent"
    }`}
  >
    <div className="px-5 py-3 flex items-center justify-between">
      {onBack ? (
        <button
          data-action-id="pageHeader.back"
          onClick={onBack}
          className="icon-btn"
        >
          <ChevronLeftIcon size={24} className="rtl:-scale-x-100" />
        </button>
      ) : (
        // Holds the slot so the header keeps its height and its actions stay put.
        <span aria-hidden="true" className="icon-btn invisible" />
      )}

      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  </header>
);

export default PageHeader;
